import { Composer } from "component/comment";
import { component, componentWithVariants, demoFile, INPUT, story, variant } from "system/demo";

demoFile('feature/comments/length-limit');

componentWithVariants('Composer', Composer, {}, [
    variant('With Length Limit', {
        features: ['lengthlimit'],
        structureKey: 'simplecomments',
    }, [
        story('Comment too short', [
            INPUT('comment-edit', 'Too short')
        ]),
        story('Comment too long', [
            INPUT('comment-edit', 'a'.repeat(1001))
        ]),
        story('Comment just right', [
            INPUT('comment-edit', 'This comment is a good length for a comment. It says enough to have some real substance and not just be a throwaway comment, but not so long as to be a burden to read. It is a comment that is just right.')
        ])
    ])
])
